// 处理id
export const getPageId = (pageId: string) => {
  return pageId.indexOf('-') > -1 ? {pageId: pageId.split('-')[0] || '', current: pageId.split('-')[1] || ''} : {pageId, current: 1}
}

// TDK设置
export const setHospitalTDK = (T: string, K: string, D: string) => {
  document.title = T;
  document
    .querySelector('meta[name="keywords"]')
    ?.setAttribute(
      "content",
      K
    );
  document.querySelector('meta[name="description"]')?.setAttribute("content", D);
  
}
// hospital ttab
export const hospitalNav = (pageId: string) => [
  { key: 0, title: '主页', reg: /hospital\/\d+$/, url: `/hospital/${pageId}`, nofollow: true },
  { key: 1, title: '详细介绍', reg: /\d+\/jieshao$/, url: `/hospital/${pageId}/jieshao` },
  { key: 2, title: '科室列表', reg: /\d+\/keshilist$/, url: `/hospital/${pageId}/keshilist` },
  { key: 3, title: '推荐医生', reg: /\d+\/yishenglist$/, url: `/hospital/${pageId}/yishenglist` },
  { key: 4, title: '患者评价', reg: /\d+\/dianpinglist$/, url: `/hospital/${pageId}/dianpinglist` },
  { key: 5, title: '问诊记录', reg: /\d+\/qalist$/, url: `/hospital/${pageId}/qalist` },
  { key: 6, title: '科普文章', reg: /\d+\/articlelist$/, url: `/hospital/${pageId}/articlelist` },
]
// departNav tab
export const departNav = (Ids: string) => [
  { key: 0, title: '主页', reg: /department\/[0-9\-]+$/, url: `/hospital/department/${Ids}`, nofollow: true },
  { key: 3, title: '科室医生', reg: /department\/[0-9\-]+\/yishenglist$/, url: `/hospital/department/${Ids}/yishenglist` },
  { key: 4, title: '患者评价', reg: /department\/[0-9\-]+\/dianpinglist$/, url: `/hospital/department/${Ids}/dianpinglist` },
  { key: 5, title: '问诊记录', reg: /department\/[0-9\-]+\/wenzhenlist$/, url: `/hospital/department/${Ids}/wenzhenlist` },
  { key: 6, title: '科普文章', reg: /department\/[0-9\-]+\/articlelist$/, url: `/hospital/department/${Ids}/articlelist` },
]
// doctor tab
export const doctorNav = (pageId: string) => [
  { key: 0, title: '主页', reg: /doctor\/\d+$/, url: `/doctor/${pageId}`, nofollow: true },
  { key: 1, title: '详情介绍', reg: /jianjie\/\d+$/, url: `/jianjie/${pageId}`},
  { key: 2, title: '患者评价', reg: /dianping\/\d+$/, url: `/dianping/${pageId}`},
  { key: 3, title: '问诊记录', reg: /qalist\/\d+$/, url: `/qalist/${pageId}`},
]